import apiClient from "services/axios";

const API = {
  recordList: "/api/v1/gauges/records",
  recordTotal: "/api/v1/gauges/totals",
  clearData: "/api/v1/gauges/records/{id}/clear",
};

export const recordList = async (filter) => {
  const response = await apiClient.get(API.recordList, { params: filter });
  if (response) {
    return response.data;
  }
  return false;
};

export const recordTotal = async (filter) => {
  const response = await apiClient.get(API.recordTotal, { params: filter });
  if (response) {
    return response.data;
  }
  return false;
};

export const clearData = async (id, body) => {
  const response = await apiClient.post(API.clearData.replace("{id}", id), body);
  if (response) {
    return response.data;
  }
  return false;
};
